import {Pipe, PipeTransform} from '@angular/core';
import {DataAccessStepName, DataAccessStepNameMap} from '@app/views/dashboard/dashboard.model';
import {JobManagementService} from '@app/core/service/job-management.service';

@Pipe({
    name: 'dataAccessStepFriendlyName'
})
export class DataAccessStepFriendlyNamePipe implements PipeTransform {

    constructor(private jobManagementService: JobManagementService) { }

    transform(value: DataAccessStepName, isTooltip: boolean = false, isJobDetail: boolean = false): any {
        return this.jobManagementService.getDataAccessStepFriendlyName(value, isTooltip, isJobDetail);
    }
}
